"use client";

import OptionSelect from "@/components/select/option-select";
import { listingTypeOption } from "@/constants/listingType";

interface ListingTypeSelectProps {
  label?: string;
  placeholder?: string;
  wrapperClassName?: string;
  value?: string | null;
  onChange?: (value: string | null) => void;
  showClearButton?: boolean;
  className?: string;
}

export default function ListingTypeSelect({
  label = "نوع معامله",
  placeholder = "نوع معامله را انتخاب کنید",
  wrapperClassName,
  value,
  onChange,
  showClearButton = true,
  className,
}: Readonly<ListingTypeSelectProps>) {
  return (
    <OptionSelect
      options={listingTypeOption}
      label={label}
      placeholder={placeholder}
      wrapperClassName={wrapperClassName}
      value={value}
      onChange={onChange}
      showClearButton={showClearButton}
      className={className}
    />
  );
}
